import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  FormGroup,
  Label,
  Input,
  CustomInput,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { api_route } from "../../Api-config/config";

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "User Profile", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: [],
    };
  }

  componentDidMount() {
    this.fetchProfile();
  }

  fetchProfile = () => {
    fetch(api_route + "/user/profile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        id: sessionStorage.getItem("dealerId"),
        token: sessionStorage.getItem("token"),
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ tableData: json, isLoading: false });
      });
  };

  render() {
    console.log(this.state.tableData);
    if (this.state.tableData.length === 0) {
      return (
        <React.Fragment>
          <div className="page-content">
            <Container fluid>
              <Breadcrumbs
                title="User Profile"
                breadcrumbItems={this.state.breadcrumbItems}
              />

              <Row>
                <Col xs={12}>
                  <Card>
                    <CardBody>
                      <FormGroup row>
                        <Label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Your Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-text-input"
                            readonly
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-search-input"
                          className="col-md-2 col-form-label"
                        >
                          Category
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-search-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-email-input"
                          className="col-md-2 col-form-label"
                        >
                          Pan No
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-email-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-url-input"
                          className="col-md-2 col-form-label"
                        >
                          Email Id
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="email"
                            id="example-url-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-tel-input"
                          className="col-md-2 col-form-label"
                        >
                          Contact No.
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="tel"
                            id="example-tel-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-password-input"
                          className="col-md-2 col-form-label"
                        >
                          Bank Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-password-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-number-input"
                          className="col-md-2 col-form-label"
                        >
                          Bank Account No.
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="number"
                            id="example-number-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-datetime-local-input"
                          className="col-md-2 col-form-label"
                        >
                          Account Type
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-datetime-local-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-date-input"
                          className="col-md-2 col-form-label"
                        >
                          IFSC Code
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-date-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-month-input"
                          className="col-md-2 col-form-label"
                        >
                          Branch
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-month-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-week-input"
                          className="col-md-2 col-form-label"
                        >
                          DP Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-week-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          DPID / Client Id
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          City
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          State
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          Pincode
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="number"
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          Address
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="page-content">
            <Container fluid>
              <Breadcrumbs
                title="User Profile"
                breadcrumbItems={this.state.breadcrumbItems}
              />

              <Row>
                <Col xs={12}>
                  <Card>
                    <CardBody>
                      <FormGroup row>
                        <Label
                          htmlFor="example-text-input"
                          className="col-md-2 col-form-label"
                        >
                          Your Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            value={this.state.tableData[0].buyerName}
                            id="example-text-input"
                            readonly
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-search-input"
                          className="col-md-2 col-form-label"
                        >
                          Category
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].category}
                            id="example-search-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-email-input"
                          className="col-md-2 col-form-label"
                        >
                          Pan No
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].panNo}
                            id="example-email-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-url-input"
                          className="col-md-2 col-form-label"
                        >
                          Email Id
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="email"
                            defaultValue={this.state.tableData[0].email}
                            id="example-url-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-tel-input"
                          className="col-md-2 col-form-label"
                        >
                          Contact No.
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="tel"
                            defaultValue={this.state.tableData[0].contactNo}
                            id="example-tel-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-password-input"
                          className="col-md-2 col-form-label"
                        >
                          Bank Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].bankName}
                            id="example-password-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-number-input"
                          className="col-md-2 col-form-label"
                        >
                          Bank Account No.
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="number"
                            defaultValue={this.state.tableData[0].bankAc}
                            id="example-number-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-datetime-local-input"
                          className="col-md-2 col-form-label"
                        >
                          Account Type
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].acType}
                            id="example-datetime-local-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-date-input"
                          className="col-md-2 col-form-label"
                        >
                          IFSC Code
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].ifscCode}
                            id="example-date-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-month-input"
                          className="col-md-2 col-form-label"
                        >
                          Branch
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].branch}
                            id="example-month-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-week-input"
                          className="col-md-2 col-form-label"
                        >
                          DP Name
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].dpName}
                            id="example-week-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          DPID / Client Id
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].dpid}
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          City
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].city}
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          State
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].state}
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          Pincode
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="number"
                            defaultValue={this.state.tableData[0].pincode}
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label
                          htmlFor="example-time-input"
                          className="col-md-2 col-form-label"
                        >
                          Address
                        </Label>
                        <Col md={10}>
                          <Input
                            className="form-control"
                            type="text"
                            defaultValue={this.state.tableData[0].address}
                            id="example-time-input"
                            disabled={true}
                          />
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default UserProfile;
